import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { defaultTablePageSize } from "../components/consts";

export const usePagedQuery = <T>(
  queryKey: string[],
  pagedQueryFn: (offset: number, limit: number) => Promise<T>,
  pageSize = defaultTablePageSize
) => {
  const [page, setPage] = useState(0);
  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const offset = page * pageSize;
  const limit = pageSize;

  const query = useQuery([...queryKey, page, pageSize], {
    queryFn: () => pagedQueryFn(offset, limit),
  });

  return {
    page,
    pageSize,
    handlePageChange,
    ...query,
  };
};
